<template>
  <div>
    <CollectionBookings v-if="isAdmin"></CollectionBookings>
  </div>
</template> 

<script>
import CollectionBookings from "@/components/bookings/admin/CollectionBookings";
export default {
  name: 'AdminCollections',
  components: { CollectionBookings },
  data() {
    return {}
  },
  computed: {
    isAdmin() {
      return this.$store.getters['auth/isAdmin'];
    }
  }
}
</script>

<style lang="scss" scoped>

</style>